module.exports = __webpack_public_path__ + "img/catalog-location.9c118b61.png";